export const curriculumItems = [
  {
    id: 'practical-life',
    title: 'Practical Life',
    description: 'Building independence through real-life activities.',
    icon: '/images/curriculum/icons/practical-life.png',
    detailImage: '/images/curriculum/photos/practical-life.jpg',
    color: '#2d6a4f',
  },
  {
    id: 'sensorial',
    title: 'Sensorial',
    description: 'Refining the senses and strengthening observation.',
    icon: '/images/curriculum/icons/sensorial.png',
    detailImage: '/images/curriculum/photos/sensorial.jpg',
    color: '#7b2cbf',
  },
  {
    id: 'language',
    title: 'Language',
    description: 'Developing communication, reading and writing skills.',
    icon: '/images/curriculum/icons/language.png',
    detailImage: '/images/curriculum/photos/language.jpg',
    color: '#e07a9a',
  },
  {
    id: 'mathematics',
    title: 'Mathematics',
    description: 'Understanding numbers, patterns and logical thinking.',
    icon: '/images/curriculum/icons/maths.png',
    detailImage: '/images/curriculum/photos/maths.jpg',
    color: '#4ea8de',
  },
  {
    id: 'cultural',
    title: 'Cultural Studies',
    description: 'Exploring the world, people, history and our environment.',
    icon: '/images/curriculum/icons/cultural.png',
    detailImage: '/images/curriculum/photos/cultural.jpg',
    color: '#2a9d8f',
  },
  {
    id: 'science',
    title: 'Science',
    description: 'Encouraging curiosity through exploration and discovery.',
    icon: '/images/curriculum/icons/science.png',
    detailImage: '/images/curriculum/photos/science.jpg',
    color: '#e76f51',
  },
  {
    id: 'art',
    title: 'Art',
    description: 'Fostering creativity and self-expression through art.',
    icon: '/images/curriculum/icons/art.png',
    detailImage: '/images/curriculum/photos/art.jpg',
    color: '#9d4edd',
  },
];
